import { useHttpClient } from "@/common/api/httpClient";
import { storeToRefs } from "pinia";
import { useLanguageStore } from "shared/translations/stores/languageStore";
import { useShapeStore } from "shared/shapes/stores/shapeStore";

export interface DeleteShapeRequest {
  shapeId: string;
}

export interface DeleteShapeResponse {
  ok: true;
}

export function useDeleteShape() {
  const httpClient = useHttpClient();
  const languageStore = useLanguageStore();
  const { translations } = storeToRefs(languageStore);
  const shapeStore = useShapeStore();

  return {
    execute
  };

  async function execute(action: DeleteShapeRequest) {
    const shapeId = action.shapeId;
    const headers = httpClient.defaultHeaders();
    const request = new Request(httpClient.siteUrl(`shape/${shapeId}`), {
      headers,
      method: 'DELETE'
    });

    const text = translations.value.shapes.actions.delete;

    const response = await httpClient.action<DeleteShapeResponse>(request, {
      title: text.title,
      errorTitle: text.error,
      async processOk() {
        shapeStore.remove(shapeId);
        return {
          ok: true
        };
      },
    });

    return response;
  }
}
